import { getRemoteContent } from '../communication/ajax';
import type { at } from '../generated/Beans';
type RemoteContent = at.sense.portlets.saf.virtualvisitpatient.model.RemoteContent;
import { create } from 'zustand';
import { PortletStoreApi } from '../App';
import { ViewStateStoreApi } from './viewState.store';

export interface RemoteContentStore {
  remotePages: RemoteContent[];
  loaded: boolean;
  getData: () => Promise<void>;
}

export const [useRemoteContentStore] = create<RemoteContentStore>(set => ({
  loaded: false,
  remotePages: [],
  getData: async () => {
    const response = await getRemoteContent({
      url: PortletStoreApi.getState().url,
      institutionId:
        ViewStateStoreApi.getState().viewStateData?.selectedInstitution.id || ''
    });

    set(state => (state.remotePages = response.data));
    set(state => (state.loaded = true));
  }
}));
